import { createColumns } from "../framework/tabulars";

export function tabularAcademies(fields) {
  return createColumns(fields, [], [], "all", "all");
}

export function academiesColumnOverrides() {
  return {
    academy_name: {
      allowHeaderFiltering: true,
    },
  };
}
